import React, { useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import { TextareaField } from '../../../utils/InputField';
import { handleChangeCustomerStatusOpe } from '../CustomerOperation';

function CustomerStatusChangeModal({ data, setReloadKey, setInfoReloadKey }) {
    const { id, status } = data;
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const { setMessage, setConfirm } = useTemplate();
    const [formData, setFormData] = useState({
        Id: id,
        Status: status === 'active' ? 'inactive' : 'active',
        Note: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    const handleCustomerStatusUpdate = (e) => {
        setLoading(true);
        e.preventDefault();
        handleChangeCustomerStatusOpe(formData, id, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                setReloadKey((d) => d + 1);
                setInfoReloadKey((d) => d + 1);
                setConfirm(null);
            })
            .catch((err) => {
                setLoading(false);
                setMessage({ type: 'error', text: err.toString(0) });
            });
    };

    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleCustomerStatusUpdate} className="w-full flex flex-col gap-2">
            <p className="text-base font-normal">
                Are you sure you want to{' '}
                <span className="text-error font-medium">{formData?.Status}</span> this customer??
            </p>
            <TextareaField
                name="Note"
                placeholder="Write your notes....."
                formData={formData}
                onChange={handleChange}
                className="h-20 *:resize-none"
            />
            <p className="text-error text-xs text-left ">This field is required.</p>
            <div className="w-full flex justify-end items-center gap-2">
                <ButtonCancel title="Cancel" onClick={() => setConfirm(null)} />
                <ButtonPrimary
                    title="Save"
                    btnType="submit"
                    className={{ 'bg-error': status === 'active' }}
                    loading={loading}
                />
            </div>
        </form>
    );
}

export default CustomerStatusChangeModal;
